class ChatAction {
  constructor(data, intent) {
    this.data = data
    this.intent = intent || {}
  }

  get name() {
    return ""
  }

  get next() {
    return this.intent.next || null
  }

  get callback() {
    return this.intent.callback || null
  }

  getResponseContent(value) {
    return value
  }
}

export default ChatAction
